import { render } from "./CompanyDashboard.vue?vue&type=template&id=335df510&scoped=true"
import script from "./CompanyDashboard.vue?vue&type=script&lang=js"
export * from "./CompanyDashboard.vue?vue&type=script&lang=js"

import "./CompanyDashboard.vue?vue&type=style&index=0&id=335df510&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335df510"]])

export default __exports__